// extracted by mini-css-extract-plugin
export var container = "_ul-0";
export var table = "_ul-2";
export var tableWrapper = "_ul-1";